// ---------------------------------------------- modules import
import React, { FunctionComponent } from "react";

import { IDetailsProps } from "./common";
import { ThemeContext } from "../../../contexts/themeContext";

// ---------------------------------------------- the component
const Details: FunctionComponent<IDetailsProps> = ({
  user,
  onToggleTheme,
  onToggleReset
}) => {
  const { name, email } = user;

  // ---------------------------------------------- content
  return (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <div className="card col s12 m8 offset-m2">
          <div className="card-content" style={{ paddingBottom: "0px" }}>
            <span style={{ fontSize: "0.75rem" }}>user settings</span>

            <span className="card-title">MY PROFILE</span>

            <ul
              className="collection"
              style={{ fontSize: "0.85rem", marginTop: "20px" }}
            >
              <li className="collection-item">
                <div>
                  Name
                  <span className="secondary-content">{name}</span>
                </div>
              </li>

              <li className="collection-item">
                <div>
                  Email
                  <span className="secondary-content">{email}</span>
                </div>
              </li>
            </ul>
          </div>

          <div
            className="card-action right-align"
            style={{ marginBottom: "0" }}
          >
            <button
              type="button"
              className="btn-floating btn-small waves-effect waves-light"
              style={{ backgroundColor: theme.ui, margin: "0 5px" }}
              onClick={() => onToggleTheme()}
            >
              <i className="tiny material-icons">color_lens</i>
            </button>

            <button
              type="button"
              className="btn-floating btn-small waves-effect waves-light"
              style={{ backgroundColor: theme.ui, marginLeft: "5px" }}
              onClick={() => onToggleReset()}
            >
              <i className="tiny material-icons">lock</i>
            </button>
          </div>
        </div>
      )}
    </ThemeContext.Consumer>
  );
};

export default Details;
